<div class="shrink-0 flex flex-row items-center justify-start gap-x-4 sm:gap-x-6">
  <div>
    <div class="inline-flex gap-x-2">
      <h3 class="text-md font-semibold text-primary">SHOUT Admin Options</h3>
    </div>
    <p class="mt-0 text-xs text-secondary">Available to Role 6</p>
  </div>
</div>

<div class="flex flex-row items-center justify-end gap-x-4">
  <div class="hidden sm:block">
    <nav aria-label="Tabs" class="flex space-x-2 items-center">
      @for (tab of tabs; track tab.id) {
      <a
        [routerLink]="tab.path"
        class="rounded-md px-3 py-2 text-sm font-medium cursor-pointer"
        [class]="getTabClass(tab.id)"
      >
        {{ tab.label }}
      </a>
      }
      <a
        *appHasRole="taxRoles"
        routerLink="/admin-options/tax"
        class="rounded-md px-3 py-2 text-sm font-medium cursor-pointer"
        [class]="getTabClass('tax')"
        [attr.aria-current]="isTabActive('tax') ? 'page' : null"
      >
        Tax
      </a>
      <a
        routerLink="/admin-options/cancellations"
        class="rounded-md px-3 py-2 text-sm font-medium cursor-pointer"
        [class]="getCancellationsLinkClass()"
        [attr.aria-current]="isCancellationsActive() ? 'page' : null"
      >
        Cancellations
      </a>
      <a
        routerLink="/admin-options/branding"
        class="rounded-md px-1 py-2 text-sm font-medium cursor-pointer"
        [class]="getBrandingLinkClass()"
        aria-label="Branding"
        [attr.aria-current]="isBrandingActive() ? 'page' : null"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          aria-hidden="true"
        >
          <circle cx="13.5" cy="6.5" r="0.5" fill="currentColor" />
          <circle cx="17.5" cy="10.5" r="0.5" fill="currentColor" />
          <circle cx="8.5" cy="7.5" r="0.5" fill="currentColor" />
          <circle cx="6.5" cy="12.5" r="0.5" fill="currentColor" />
          <path
            d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10c.926 0 1.648-.746 1.648-1.688 0-.437-.18-.835-.437-1.125-.29-.289-.438-.652-.438-1.125a1.64 1.64 0 0 1 1.668-1.668h1.996c3.051 0 5.555-2.503 5.555-5.554C21.965 6.012 17.461 2 12 2z"
          />
        </svg>
      </a>
      <a
        routerLink="/admin-options/google-analytics"
        class="rounded-md px-1 py-2 text-sm font-medium cursor-pointer"
        [class]="getGoogleAnalyticsLinkClass()"
        aria-label="Google Analytics"
        [attr.aria-current]="isGoogleAnalyticsActive() ? 'page' : null"
      >
        <img
          [ngSrc]="googleAnalyticsIconUrl"
          width="24"
          height="24"
          alt=""
          class="size-6"
          aria-hidden="true"
        />
      </a>
      <a
        routerLink="/admin-options/settings"
        class="rounded-md px-1 py-2 text-sm font-medium cursor-pointer"
        [class]="getSettingsLinkClass()"
        aria-label="Settings"
        [attr.aria-current]="isSettingsActive() ? 'page' : null"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="lucide lucide-settings-icon lucide-settings"
        >
          <path
            d="M9.671 4.136a2.34 2.34 0 0 1 4.659 0 2.34 2.34 0 0 0 3.319 1.915 2.34 2.34 0 0 1 2.33 4.033 2.34 2.34 0 0 0 0 3.831 2.34 2.34 0 0 1-2.33 4.033 2.34 2.34 0 0 0-3.319 1.915 2.34 2.34 0 0 1-4.659 0 2.34 2.34 0 0 0-3.32-1.915 2.34 2.34 0 0 1-2.33-4.033 2.34 2.34 0 0 0 0-3.831A2.34 2.34 0 0 1 6.35 6.051a2.34 2.34 0 0 0 3.319-1.915"
          />
          <circle cx="12" cy="12" r="3" />
        </svg>
      </a>
    </nav>
  </div>
</div>
